"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.treasureCanisterId = void 0;
exports.treasureCanisterId = 'yigae-jqaaa-aaaah-qczbq-cai';
